module.exports = __webpack_public_path__ + "img/enterBg1.jpg";